import { render } from "./VerifyContract.vue?vue&type=template&id=88491b06"
import script from "./VerifyContract.vue?vue&type=script&lang=js"
export * from "./VerifyContract.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__